module.exports = __webpack_public_path__ + "static/img/product3s-2.94987f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3s-2.jpg
// module id = bBZu
// module chunks = 0